import React, { useState } from 'react'
import { Button } from './ui/button'
import { ImageIcon } from 'lucide-react'
import { VisualizationPanel } from './VisualizationPanel'

interface VisualizationButtonProps {
  projectId: string
  projectName?: string
  disabled?: boolean
}

export function VisualizationButton({ projectId, projectName, disabled }: VisualizationButtonProps) {
  const [isPanelOpen, setIsPanelOpen] = useState(false)

  return (
    <>
      <Button
        variant="outline"
        size="sm"
        onClick={() => setIsPanelOpen(true)}
        disabled={disabled}
      >
        <ImageIcon className="w-4 h-4 mr-2" />
        Visualizations
      </Button>

      <VisualizationPanel
        projectId={projectId}
        projectName={projectName}
        isOpen={isPanelOpen}
        onClose={() => setIsPanelOpen(false)}
      />
    </>
  )
}
